import { useAuth } from "features/auth/hooks/useAuth";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { AppRoute } from "shared/types/AppRoute";

interface Props {
  route: AppRoute;
  children: ReactNode;
}

export default function ProtectedAuthRoute({ route, children }: Props) {
  const { user, isLoading } = useAuth();

  if (isLoading) return null;

  if (user) return <Navigate to="/" />;

  return children;
}
